export const ORIENTATION_CHAPTER_NUMBER = 0;
